import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { QuoteService } from 'src/app/service/quote.service';
import { FormArray, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { AddressModel, GetQuoteResponseModel, MemberModel, PhoneModel } from 'src/app/service/web-api-client';
@Component({
  selector: 'app-quote-step10-desktop',
  templateUrl: './quote-step10-desktop.component.html',
  styleUrls: ['./quote-step10-desktop.component.css']
})
export class QuoteStep10DesktopComponent implements OnInit {
  ballPink1srcNew: string = '/assets/external/newbasketball-resize.png'
  vectorUnFilled: string = '/assets/external/vector3387-ovts.svg'
  vectorfilled: string = '/assets/external/vector3387-ynbm.svg'
  towerNew: string = '/assets/external/tower-new-resize.png'
  @Input()
  ellipse25src3: string = '/assets/external/ellipse253402-hr23.svg'
  @Input()
  ellipse25src1: string = '/assets/external/ellipse253402-cnw.svg'
  @Input()
  vectorsrc1: string = '/assets/external/vector3402-fmh4.svg'
  @Input()
  vectoralt7: string = 'VectorI3402'
  @Input()
  vectorsrc6: string =
    'https://aheioqhobo.cloudimg.io/v7/_playground-bucket-v2.teleporthq.io_/3d4a8b38-23a4-4c0d-916f-173c88c76ea4/a0f31d78-a2f3-4a77-8ab5-56ed630c103a?org_if_sml=1624&force_format=original'
  @Input()
  ellipse25alt4: string = 'Ellipse253402'
  @Input()
  vectoralt14: string = 'VectorI3402'
  @Input()
  inputplaceholder2: string = 'Andrea'
  @Input()
  vectoralt5: string = 'VectorI3402'
  @Input()
  ellipse25src: string = '/assets/external/ellipse253402-g1l.svg'
  @Input()
  vectoralt11: string = 'VectorI3402'
  @Input()
  ellipse25alt2: string = 'Ellipse253402'
  @Input()
  vectoralt6: string = 'VectorI3402'
  @Input()
  vectorsrc: string = '/assets/external/vector3402-wc8t.svg'
  @Input()
  rootClassName: string = ''
  @Input()
  ellipse25alt: string = 'Ellipse253402'
  @Input()
  inputplaceholder4: string = '114040276'
  @Input()
  vectoralt15: string = 'VectorI3402'
  @Input()
  vectoralt10: string = 'VectorI3402'
  @Input()
  vectorsrc8: string =
    'https://aheioqhobo.cloudimg.io/v7/_playground-bucket-v2.teleporthq.io_/3d4a8b38-23a4-4c0d-916f-173c88c76ea4/59b32ba9-2261-41eb-8a6c-b6c9d803d5ed?org_if_sml=1503&force_format=original'
  @Input()
  vectoralt12: string = 'VectorI3402'
  @Input()
  vectorsrc2: string = '/assets/external/vector3402-i3kh.svg'
  @Input()
  vectorsrc15: string =
    'https://aheioqhobo.cloudimg.io/v7/_playground-bucket-v2.teleporthq.io_/3d4a8b38-23a4-4c0d-916f-173c88c76ea4/6868296e-f576-4373-b3b8-cccc2381485c?org_if_sml=1490&force_format=original'
  @Input()
  vectoralt1: string = 'Vector3402'
  @Input()
  inputplaceholder: string = 'Andrea'
  @Input()
  vectorsrc3: string = '/assets/external/vector3402-z84b.svg'
  @Input()
  inputplaceholder1: string = 'Amador Montoya'
  @Input()
  vectorsrc4: string = '/assets/external/vector3402-pmh.svg'
  @Input()
  vectoralt13: string = 'VectorI3402'
  @Input()
  vectorsrc10: string =
    'https://aheioqhobo.cloudimg.io/v7/_playground-bucket-v2.teleporthq.io_/3d4a8b38-23a4-4c0d-916f-173c88c76ea4/f9f8dfc4-1735-41d9-a0d2-db4343c798a8?org_if_sml=1517&force_format=original'
  @Input()
  inputplaceholder3: string = 'Amador Montoya'
  @Input()
  ellipse25src4: string = '/assets/external/ellipse253402-keq4.svg'
  @Input()
  vectorsrc13: string =
    'https://aheioqhobo.cloudimg.io/v7/_playground-bucket-v2.teleporthq.io_/3d4a8b38-23a4-4c0d-916f-173c88c76ea4/6bc5c84e-cf24-43d2-8123-ee11f050561f?org_if_sml=1222&force_format=original'
  @Input()
  vectoralt9: string = 'VectorI3402'
  @Input()
  vectorsrc9: string =
    'https://aheioqhobo.cloudimg.io/v7/_playground-bucket-v2.teleporthq.io_/3d4a8b38-23a4-4c0d-916f-173c88c76ea4/238da2e3-a112-417b-9364-a56b74fca98b?org_if_sml=1633&force_format=original'
  @Input()
  vectorsrc7: string =
    'https://aheioqhobo.cloudimg.io/v7/_playground-bucket-v2.teleporthq.io_/3d4a8b38-23a4-4c0d-916f-173c88c76ea4/b3f0a6c8-cb74-4cab-9647-d0c46e6e3d39?org_if_sml=1171&force_format=original'
  @Input()
  vectorsrc5: string =
    'https://aheioqhobo.cloudimg.io/v7/_playground-bucket-v2.teleporthq.io_/3d4a8b38-23a4-4c0d-916f-173c88c76ea4/625bf10b-08c2-41a4-9372-c717258fe23d?org_if_sml=11330&force_format=original'
  @Input()
  ellipse25src2: string = '/assets/external/ellipse253402-opof.svg'
  @Input()
  vectoralt2: string = 'Vector3402'
  @Input()
  vectoralt3: string = 'Vector3402'
  @Input()
  ellipse25alt3: string = 'Ellipse253402'
  @Input()
  vectoralt8: string = 'VectorI3402'
  @Input()
  ellipse25alt1: string = 'Ellipse253402'
  @Input()
  vectorsrc11: string =
    'https://aheioqhobo.cloudimg.io/v7/_playground-bucket-v2.teleporthq.io_/3d4a8b38-23a4-4c0d-916f-173c88c76ea4/d9885150-a385-4cdd-a89e-e451bf259584?org_if_sml=1744&force_format=original'
  @Input()
  vectorsrc12: string =
    'https://aheioqhobo.cloudimg.io/v7/_playground-bucket-v2.teleporthq.io_/3d4a8b38-23a4-4c0d-916f-173c88c76ea4/e61f9a32-8b55-4366-8421-f6f15ed6e186?org_if_sml=1743&force_format=original'
  @Input()
  vectoralt: string = 'Vector3402'
  @Input()
  vectorsrc14: string =
    'https://aheioqhobo.cloudimg.io/v7/_playground-bucket-v2.teleporthq.io_/3d4a8b38-23a4-4c0d-916f-173c88c76ea4/9386d4be-a2a5-43d2-a90e-2c7672713133?org_if_sml=1740&force_format=original'
  @Input()
  vectoralt4: string = 'Vector3402'

  @Input() screenWidth: number;
  @Input() currentStep: number;
  @Output() onNextStep: EventEmitter<number> = new EventEmitter();
  @Output() onPrevStep: EventEmitter<number> = new EventEmitter();
  lastYear: number = new Date().getFullYear()

  constructor(private quoteService: QuoteService, private fb: FormBuilder,) {

    this.createForm();

  }
  stepTenForm: FormGroup;
  stepElevenForm: FormGroup;
  submitted = false;
  allSubmitted = false;

  above65Members: number = 0;
  below65Members: number = 0;

  createForm() {
    this.stepTenForm = this.fb.group({ rows: this.fb.array([]) });
    this.stepElevenForm = this.fb.group({ rows: this.fb.array([]) });

  }

  get rows(): FormArray {
    return this.stepTenForm.get('rows') as FormArray || this.fb.array([]);
  }

  get rows65(): FormArray {
    return this.stepElevenForm.get('rows') as FormArray || this.fb.array([]);
  }

  createRow(): FormGroup {
    return this.fb.group({
      dayBirth: [null, [Validators.required, Validators.min(1), Validators.max(31), Validators.pattern(/^[0-9]*$/)]],
      monthBirth: [null, [Validators.required, Validators.min(1), Validators.max(12), Validators.pattern(/^[0-9]*$/)]],
      yearBirth: [null, [Validators.required, Validators.min(1900), Validators.max(this.lastYear), Validators.pattern(/^[0-9]*$/)]],
      firstName: ['', Validators.required],
      lastName: ['', Validators.required],
      pasaportNo: ['', Validators.required],
      relationship: ['', Validators.required],
      memberId: [''],
      isSubmitted: [false],
      isLoading: [false],
      isError65: [false]
    });
  }
  submitDependent(i, isOver65 = true): void {

    this.submitted = true;
    const row = isOver65 ? this.rows65.at(i) : this.rows.at(i); // Get the specific row FormGroup
    row.patchValue({ isSubmitted: true, isLoading: true });
    row.markAsDirty(); // Mark the row as dirty
    row.updateValueAndValidity(); // Recalculate validation

    if (row.valid) {
      const self = this;
      const formValues = row.value
      const birthdate = `${formValues.yearBirth}-${this.formatTwoDigits(formValues.monthBirth)}-${this.formatTwoDigits(formValues.dayBirth)}`;
      if (isOver65) {
        if (!this.isAbove65(new Date(birthdate))) {
          row.patchValue({ isLoading: false, isError65: true });
          return
        } else {
          row.patchValue({ isError65: false });
        }
      } else {
        // Validate that dependents under 65 are actually under 65 years old
        if (this.isAbove65(new Date(birthdate))) {
          row.patchValue({ isLoading: false, isError65: true });
          return
        } else {
          row.patchValue({ isError65: false });
        }
      }


      const memberId = row.value.memberId;
      let member = new MemberModel({
        firstName: formValues.firstName,
        lastName: formValues.lastName,
        passportNumber: formValues.pasaportNo,
        relation: formValues.relationship,
        memberTypeId: 2,
        isDependent: true,
        countryId: formValues.pais,
        birthdate: birthdate,
        email: this.quoteService.quoteModel.members[0].email,        
      });
      if(this.quoteService.quoteModel.members[0].address){
        member.address = new AddressModel({
          address1: this.quoteService.quoteModel.members[0].address.address1,
          state: this.quoteService.quoteModel.members[0].address.state,
          city: this.quoteService.quoteModel.members[0].address.city,
          postalCode: this.quoteService.quoteModel.members[0].address.postalCode,
        })
      }
      if (memberId) {
        member.memberId = memberId
      } else {
        member.memberId = 0;
      }

      // Get the owner (memberTypeId = 1) - it must always be included in the API call
      const ownerMember = (this.quoteService.quoteModel?.members || []).find(m => {
         return m.memberTypeId === 1 || m.memberType?.id === 1;
      });
      
      const owner = ownerMember ? new MemberModel({
        ...ownerMember,
        memberTypeId: 1,
        countryId: ownerMember.country?.id || ownerMember.countryId
      }) : null;

      if (!owner) {
        row.patchValue({ isLoading: false });
        console.error('Owner member not found. Cannot proceed without owner.');
        return;
      }

      // Always include owner + the dependent being added
      // Also include any other existing dependents to prevent them from being deleted
      const existingDependents = (this.quoteService.quoteModel?.members || []).filter(m => {
        const memberType = m.memberTypeId || m.memberType?.id || 0;
        return memberType === 2 && m.memberId !== member.memberId;
      });

      // Create members array: owner + existing dependents + new/updated dependent
      const membersToSend = [owner, ...existingDependents, member];

      // Create a temporary quote model with the members array
      const tempQuoteModel = new GetQuoteResponseModel({
        ...this.quoteService.quoteModel,
        members: membersToSend
      });

      const result = this.quoteService.updateCertificate$(tempQuoteModel).subscribe(r => {
        r.members.forEach(member => {
          member.memberTypeId = member.memberType.id;
          if(member.memberTypeId === 1) {
            member.countryId = member.country.id;
            member.phones = member.phones.map(phone => {
              phone.phoneTypeId = phone.phoneType.id;
              return phone;
            });
          }
        });

        const resultJson = JSON.stringify(r);
        const result = JSON.parse(resultJson);
        const getTrigerElemnts = document.getElementsByClassName(`p-accordion-header-link`) as HTMLCollectionOf<HTMLElement>;
        try {
          self.quoteService.quoteModel = result;
          row.patchValue({ isLoading: false });
          if (isOver65) {
            if (getTrigerElemnts[i ]) {
              getTrigerElemnts[i].click();
            }

            if (getTrigerElemnts[i + 1]) {
              getTrigerElemnts[i + 1].click()
            };

          } else {
            const member = (this.above65Members || 0) + i + 1;
            if (getTrigerElemnts[member]) {
              getTrigerElemnts[member].click();
            }
            if ((member) == (this.above65Members || 0) + (this.below65Members || 0)) {
              getTrigerElemnts[member - 1].click()
            };
          }
          self.resetForm();
        } catch (error) {
          console.log('error', error);
        }
        return result;
      });
    } else {
      row.patchValue({ isLoading: false });
    }
  }
  submitForm(): void {
    if (this.stepTenForm.valid && this.stepElevenForm.valid) {
      this.onNextStep.emit(this.currentStep);
    } else {
      this.allSubmitted = true;
    }
  }

  nextStep(): void {
    this.onNextStep.emit(this.currentStep);
  }

  prevStep(): void {
    this.onPrevStep.emit(this.currentStep);
  }
  isAbove65(birthDate: Date): boolean {
    const today = new Date();
    const birth = new Date(birthDate);

    let age = today.getFullYear() - birth.getFullYear();
    const monthDiff = today.getMonth() - birth.getMonth();
    const dayDiff = today.getDate() - birth.getDate();

    // Adjust age if birthday hasn't occurred yet this year
    if (monthDiff < 0 || (monthDiff === 0 && dayDiff < 0)) {
      age--;
    }

    return age >= 65;
  }

  formatTwoDigits(number) {
    return number.toString().padStart(2, '0');
  }

  formatDateToDDMMYYYY(dateString) {
    const date = new Date(dateString);
    const day = String(date.getDate()).padStart(2, '0');
    const month = String(date.getMonth() + 1).padStart(2, '0'); // Months are 0-indexed
    const year = date.getFullYear();
    return `${day}/${month}/${year}`;
  }

  resetForm(): void {
    if (this.quoteService.quoteModel) {
      if (this.quoteService.quoteModel.members && this.quoteService.quoteModel.members.length > 0) {
        // Ensure form arrays are initialized
        if (!this.stepTenForm || !this.stepElevenForm) {
          return;
        }

        let isAbove65 = 0;
        let isbelow65 = 0;
        
        // Filter dependents and sort to ensure consistent ordering
        const dependents = this.quoteService.quoteModel.members.filter(member => {
          const memberTypeId = member.memberType?.id || member.memberTypeId;
          return memberTypeId === 2;
        });

        dependents.forEach((member) => {
          if (!member.birthdate) {
            return;
          }

          const birthDate = new Date(member.birthdate);
          if (isNaN(birthDate.getTime())) {
            return;
          }

          const isOver65 = this.isAbove65(birthDate);
          const form = isOver65 ? this.rows65 : this.rows;
          const rowIndex = isOver65 ? isAbove65 : isbelow65;

          // Check if the row exists before trying to set values
          if (form && rowIndex < form.length && form.at(rowIndex)) {
            const row = form.at(rowIndex);
            if (row) {
              row.get('dayBirth')?.setValue(this.formatTwoDigits(birthDate.getDate()));
              row.get('monthBirth')?.setValue(this.formatTwoDigits(birthDate.getMonth() + 1));
              row.get('yearBirth')?.setValue(this.formatTwoDigits(birthDate.getFullYear()));
              row.get('firstName')?.setValue(member.firstName || '');
              row.get('lastName')?.setValue(member.lastName || '');
              row.get('pasaportNo')?.setValue(member.passportNumber || '');
              row.get('relationship')?.setValue(member.relation || '');
              row.get('memberId')?.setValue(member.memberId || '');

              if (isOver65) {
                isAbove65++;
              } else {
                isbelow65++;
              }
            }
          }
        });
      }
    }
  }

  async ngOnInit() {
    await setTimeout(() => {

    }, 2000);
    this.above65Members = this.quoteService.quoteModel.dependentCountOver65;
    this.below65Members = this.quoteService.quoteModel.dependentCount;
    this.stepTenForm = this.fb.group({
      rows: this.fb.array(Array.from({ length: this.quoteService.quoteModel.dependentCount }, () => this.createRow()))
    });
    this.stepElevenForm = this.fb.group({
      rows: this.fb.array(Array.from({ length: this.quoteService.quoteModel.dependentCountOver65 }, () => this.createRow()))
    });
    this.resetForm();
  }

}
